import { render } from "./AboutMe.vue?vue&type=template&id=7760ad1f&scoped=true&ts=true"
import script from "./AboutMe.vue?vue&type=script&lang=ts"
export * from "./AboutMe.vue?vue&type=script&lang=ts"

import "./AboutMe.vue?vue&type=style&index=0&id=7760ad1f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7760ad1f"]])

export default __exports__